import { BoostOfferResponse, BoostOfferResponseV3 } from '@woolworthsnz/trader-api';

export enum BoostOfferStatus {
	NotActivated = 'NotActivated',
	Activated = 'Activated',
	Redeemed = 'Redeemed',
}

export type BoostOfferResponseV2 = BoostOfferResponse & BoostOfferResponseV3;
